import React from 'react'
import PropTypes from 'prop-types';

import { Updaters } from '@leverege/api-attributes'
import Util from './Util'
import { NumericInput, LabelGroup } from '~/views';

export default class RandomBooleanEditor extends React.Component {

  static TYPE = Updaters.RandomBooleanUpdaterCreator.typeName();

  static propTypes = {
    updater : PropTypes.object,
    attribute : PropTypes.object,
    blueprint : PropTypes.object,
    onChange : PropTypes.func.isRequired
  }

  constructor( props ) {
    super( props )
    this.changePath = Util.ChangePath.bind( this )
  }

  render() {
    const { updater } = this.props
    if ( updater == null ) {
      return <div />
    }

    return (
      <div>
        <LabelGroup>
          <label>Every</label>
          <div>
            <NumericInput
              hint="Seconds..." 
              value={updater.update / 1000}
              float
              size={5}
              min={0}
              onChange={( v, err ) => { this.changePath( 'update', typeof v === 'number' ? v * 1000 : v, err ) }} />
            <label style={{ padding : '0 8px' }}>seconds</label>
          </div>
        </LabelGroup>
      </div>
    ) 
  }
}
